import { styled } from '@mui/material';

export const StyledHeader = styled('div')(({ theme }) => ({
	display: 'flex',
	gap: theme.spacing(2),
	flexDirection: 'column',
	alignItems: 'center',
}));

export const StyledTitle = styled('pre')(({ theme }) => ({
	fontSize: '20px',
	fontWeight: 700,
	lineHeight: '30px',
	textAlign: 'center',
	color: theme.palette.text.secondary,
	whiteSpace: 'pre-wrap',
	[theme.breakpoints.down('md')]: {
		fontSize: '20px',
		lineHeight: '27px',
	},
}));

export const StyledButtons = styled('div')({
	width: '100%',
	display: 'flex',
	justifyContent: 'space-around',
	marginTop: '40px',
	gap: '10px',
});

export const StyledContainer = styled('div')(({ theme }) => ({
	display: 'flex',
	flexDirection: 'column',
	alignItems: 'center',
	justifyContent: 'space-between',
	padding: '25px 75px 10px 75px',
	height: 'fit-content',
	maxHeight: '850px',
	width: '812px',
	maxWidth: '812px',
	boxSizing: 'border-box',
	[theme.breakpoints.down('md')]: {
		width: '100%',
		maxWidth: '100%',
		height: ' 85vh',
		position: 'relative',
		justifyContent: 'center',
		padding: '25px 60px 10px 60px',
	},
	[theme.breakpoints.down('sm')]: {
		padding: '25px 30px 10px 30px',
	},
}));
